import api from './api'

export const saleReversalService = {
  getAll: (params?: { page?: number; limit?: number }) =>
    api.get('/sale-reversals', { params }),

  getById: (id: number) =>
    api.get(`/sale-reversals/${id}`),

  reverseSale: (data: { sale_id: number; reason: string }) =>
    api.post('/sale-reversals', data),

  getReversalReport: (params?: { startDate?: string; endDate?: string }) =>
    api.get('/sale-reversals/report', { params }),
}
